// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1eesu","buttons":"PendingPaymentAlert_buttons__312fl"};